import numeral from 'numeral'

numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'К',
    million: 'М',
    billion: 'Б',
    trillion: 'Т'
  },
  currency: {
    symbol: 'Р'
  }
});

// switch between locales
numeral.locale('ru');

export const declOfNum = (number, titles) => {
  let cases = [2, 0, 1, 1, 1, 2];
  return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
};

export const variantsDecl = (count) => {
  return declOfNum(count, ['вариант', 'варианта', 'вариантов']);
};

export const priceFormat = (price) => {
  if (price && price > 0) {
    return `${numeral(price).format('0,0.[00]')} Р`;
  } else {
    return '';
  }
};

export const errorKey = (klass) => `Open-${klass}-Select`;


// WEBPACK FOOTER //
// ./app/javascript/app/utils.jsx